import React, { FC } from 'react';
import { connect } from 'react-redux';

import { ReduxState } from 'app/redux/types';

import { StakeType } from 'app/lib/staking/constants';

import { RecordOfMatchEntryType } from '../../../records';
import { selectAnyHasLockedState, selectMatches, selectSomeHasError } from '../../../selectors/entries';
import { selectCurrentStakeType } from '../../../selectors/stakeTypes';
import Entry from '../Entry';
import ExpressInsideMatch from '../ExpressInsideMatch';

// ---

type StoreProps = {
  betIds?: RecordOfMatchEntryType['betIds'];
  isCombination: boolean;
  hasEntriesErrors: boolean;
};

type MatchProps = {
  matchId: number;
};

const Match: FC<MatchProps & StoreProps> = ({
  matchId,
  betIds,
  isCombination,
  hasEntriesErrors,
}) => {
  if (!betIds) {
    console.error('Match -> `betIds` not found');
    return null;
  }

  const isExpressInsideMatch = !hasEntriesErrors && isCombination && betIds.size > 1;

  return (
    <>
      {isExpressInsideMatch && (
        <ExpressInsideMatch matchId={matchId} />
      )}

      {!isExpressInsideMatch && betIds.map((betId) => (
        <Entry key={betId}
               betId={betId} />
      ))}
    </>
  );
};

const mapStateToProps = (state: ReduxState, { matchId }: MatchProps): StoreProps => {
  const match = selectMatches(state).get(matchId);

  return {
    betIds: match?.betIds,
    isCombination: !selectCurrentStakeType(state).has(StakeType.SINGLE),
    hasEntriesErrors: selectSomeHasError(state) || selectAnyHasLockedState(state),
  };
};

export default connect(mapStateToProps)(Match);
